import { SAVE_REFERRAL_CODE } from "./actionTypes";

export default (referralCode) => ({
  type: SAVE_REFERRAL_CODE,
  payload: {
    referralCode
  }
});